import { apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class DownloadFileAPI {
    constructor() {
        this.baseUrl = new URL("files/", apiFilesBaseURL);
    }

    downloadBusSched(schedName, providerId = '') {
        return API.authenticatedRequest({
            url: providerId === ''
                ? new URL(`download/bussched/${schedName}`, this.baseUrl)
                : new URL(`download/bussched/${schedName}?provId=${providerId}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }

    downloadMultipleBusSched(documents, providerId = '', networkId) {
        return API.authenticatedRequest({
            url: providerId === ''
                ? new URL(`download/busscheds/${networkId}`, this.baseUrl)
                : new URL(`download/busscheds/${networkId}/?provId=${providerId}`, this.baseUrl),
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(documents)
        }, false);
    }

    downloadBusmap(schedName, providerId = '') {
        return API.authenticatedRequest({
            url: providerId === ''
                ? new URL(`download/busmap/${schedName}`, this.baseUrl)
                : new URL(`download/busmap/${schedName}?provId=${providerId}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }

    downloadBusmapTransportAuthority(schedName) {
        return API.authenticatedRequest({
            url: new URL(`download/busmap/ta/${schedName}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }

    downloadExportedDocument(docName, providerId = '') {
        return API.authenticatedRequest({
            url: providerId === ''
                ? new URL(`download/export/${docName}`, this.baseUrl)
                : new URL(`download/export/${docName}?provId=${providerId}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }

    downloadSpiderMap(schedName) {
        return API.authenticatedRequest({
            url: new URL(`download/spidermap/${schedName}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        }, false);
    }
}



// WEBPACK FOOTER //
// ./src/api/files/DownloadFileAPI.js